export default "__VITE_ASSET__WKYNNdfC__"